<template>
    <div>
        <v-card elevation="0">
            <!--
                <v-card-title style="color:#6f9483;" class="text-center">
                    <v-icon color="#6f9483">mdi-file-multiple</v-icon>&nbsp;Net Bills
                </v-card-title>
            -->
            <v-card-text>
                <v-card elevation="0">
                    <v-row justify="center">
                        <v-col cols="8">
                            <v-card-text>
                                <v-menu
                                    v-model="menu"
                                    :close-on-content-click="true"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="pickedDate" label="Generation Date" prepend-icon="mdi-calendar"
                                            readonly v-bind="attrs" v-on="on" hint="Students will see this date" persistent-hint outlined
                                        >
                                            <template v-slot:append-outer>
                                                <v-dialog
                                                    v-model="dialog"
                                                    persistent
                                                    max-width="400"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            color="#8FB3A3"
                                                        >
                                                            <span style='color: white;'>Generate Net Bill</span>
                                                        </v-btn>
                                                    </template>
                                                    <v-card>
                                                        <v-toolbar color="#8FB3A3" dark>
                                                            <v-toolbar-title style="color:white;">Generate Net Bill</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-btn icon @click="dialog = false">
                                                                <v-icon color="white">mdi-close-thick</v-icon>
                                                            </v-btn>
                                                        </v-toolbar>
                                                        <v-card-text class="text-center">
                                                            <br />
                                                            You are generating Net Bills using the date below: <br /><br />
                                                            <b>{{ pickedDate }}</b>
                                                            <br />
                                                        </v-card-text>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                color="#8FB3A3"
                                                                outlined
                                                                @click="generateNetBill"
                                                                :loading="generateloading"
                                                            >
                                                                Generate
                                                            </v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="pickedDate"
                                        no-title
                                        scrollable
                                    ></v-date-picker>
                                </v-menu>
                            </v-card-text>
                        </v-col>
                        <v-col cols="8">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" v-if="!summaryloading">
                                        <v-row justify="center" align-content="center">
                                            <v-col cols="12">
                                                <v-simple-table height="400px" fixed-header>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="3">
                                                                <v-row>
                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                color="#8FB3A3"
                                                                                icon
                                                                                @click="downloadDiagnostic"
                                                                            >
                                                                                <v-icon>mdi-file-download-outline</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Download Diagnostic File</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                color="#68BBE3"
                                                                                icon
                                                                                @click="downloadComparison"
                                                                            >
                                                                                <v-icon>mdi-file-compare</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Download Comparison File</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip left>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-btn
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                color="#EF7C8E"
                                                                                @click="dialogDelete = true;"
                                                                                icon
                                                                            >
                                                                                <v-icon>mdi-delete-forever-outline</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Delete Net Bill</span>
                                                                    </v-tooltip>
                                                                    <v-dialog
                                                                        v-model="dialogDelete"
                                                                        persistent
                                                                        max-width="400"
                                                                    >
                                                                        <v-card>
                                                                            <v-toolbar color="#EF7C8E" dark>
                                                                                <v-toolbar-title style="color:white;">Delete Net Bill</v-toolbar-title>
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn icon @click="dialogDelete = false">
                                                                                    <v-icon color="white">mdi-close-thick</v-icon>
                                                                                </v-btn>
                                                                            </v-toolbar>
                                                                            <v-card-text class="text-center">
                                                                                <br />
                                                                                The current Net Bill will be deleted. Continue?
                                                                            </v-card-text>
                                                                            <v-card-actions>
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    color="#EF7C8E"
                                                                                    outlined
                                                                                    :loading="deleteloading"
                                                                                    @click="deleteNetBill"
                                                                                >
                                                                                    Delete
                                                                                </v-btn>
                                                                            </v-card-actions>
                                                                        </v-card>
                                                                    </v-dialog>
                                                                </v-row>  
                                                            </th>
                                                            <th class="text-right">
                                                                Current Net Bill is created on <b><i>{{ diagnostic.endTime.split(" ")[0]}}</i></b> <br />
                                                                Using the date <b><i>{{ diagnostic.generatedDate }}</i></b>
                                                            </th>
                                                        </tr>
                                                        <tr><th colspan="4" class="text-center">Unresolved Students</th></tr>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Account #</th>
                                                            <th>Student #</th>
                                                            <th>Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="errorList.length > 0">
                                                        <tr v-for="s in errorList" :key="s.accountnumber" >
                                                            <td class="text-caption">{{ s["firstname"]+` `+s["lastname"] }}</td>
                                                            <td class="text-caption">{{ s["accountnumber"] }}</td>
                                                            <td class="text-caption">{{ s["studentnumber"] }}</td>
                                                            <td class="text-caption">{{ s["error"] }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <tr>
                                                            <td colspan="4" class="text-center">
                                                                <i>No Unresolved Students or No Net Bill Data</i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <v-container style="height: 350px;">
                                            <v-row
                                                class="fill-height"
                                                align-content="center"
                                                justify="center"
                                            >
                                                <v-col
                                                    class="text-caption text-center"
                                                    cols="12"
                                                >
                                                    Calling last generated Net Bill info...
                                                </v-col>
                                                <v-col cols="6">
                                                <v-progress-linear
                                                    color="#8FB3A3"
                                                    indeterminate
                                                    rounded
                                                    height="6"
                                                ></v-progress-linear>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            pickedDate: new Date().toISOString().split("T")[0],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            menu: false,
            dialog: false,
            dialogDelete: false,
            deleteloading: false,
            generateloading: false,
            summaryloading: false,
            errorList: [],
            diagnostic: {
                "generatedDate": "N/A",
                "endTime": "N/A Error"
            },
        }
    },
    methods: {
        generateNetBill(){
            const that = this;
            that.generateloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?';
            
            const formData = new FormData();
            formData.append("mode", "generateNetBill");
            formData.append("pickedDate", that.pickedDate);

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(!data.result.match(/OK/i)){
                    that.setSnackbar("Warning: "+data.message, "#FFCC80"); //orange
                }else {
                    that.setSnackbar(data.message, "#18A558"); //orange
                    that.getNetBillSummary();
                }

                that.generateloading = false;
                that.dialog = false;
                
            })
            .catch(function (err) {
                that.generateloading = false;
                that.dialog = false;
                that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
            })
        },
        getNetBillSummary(){
            const that = this;
            that.summaryloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?getNetBillsummary';

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }else {
                        if(resultData.errors){
                            that.errorList = that.processErrorList(resultData.errors);
                        }else {
                            that.errorList = [];
                        }

                        if(resultData.diagnostic){
                            if(Object.keys(resultData.diagnostic) == 0){
                                that.diagnostic = {
                                    "generatedDate": "N/A",
                                    "endTime": "N/A Error"
                                }
                            }else {
                                that.diagnostic = resultData.diagnostic;
                            }
                            
                        }else {
                            that.diagnostic = {
                                "generatedDate": "N/A",
                                "endTime": "N/A Error"
                            }
                        }
                    }

                    that.summaryloading = false;

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.summaryloading = false;
                })
            //End of API GET request
        },
        processErrorList(data){
            var processed = [];
            var filtered = [];

            var duplicates = [];

            data.forEach(element => {
                if(element["studentnumber"] == ""){
                    processed.push(element);
                }else {
                    if(!duplicates.includes(element["studentnumber"])){
                        duplicates.push(element["studentnumber"]);
                        filtered.push(element);
                    }else {
                        let index = duplicates.indexOf(element["studentnumber"]);

                        filtered[index]["accountnumber"] += ", "+element["accountnumber"];
                    }
                }
            });

            return processed.concat(filtered);
        },
        deleteNetBill(){
            const that = this;
            that.deleteloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?deleteNetBill';

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }else {
                        that.setSnackbar("NetBill Deletion Successful", "#18A558"); //orange
                    }

                    that.deleteloading = false;
                    that.dialogDelete = false;

                    that.getNetBillSummary();

                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red

                    that.deleteloading = false;
                    that.dialogDelete = false;
                })
            //End of API GET request
        },
        downloadDiagnostic(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?downloadDiagnostic';

            fetch(api, {
                method: 'POST'
            })
            .then(function(response){
                return response;
            })
            .then(function(data){

                //response.status == 404 / success
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        downloadComparison(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?downloadComparison';

            fetch(api, {
                method: 'POST'
            })
            .then(function(response){
                return response;
            })
            .then(function(data){

                //response.status == 404 / success
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getNetBillSummary();
    }
}
</script>